// ============================================================
// DIRGA — CENTRALIZED PRICING & CONFIGURATION
// Edit prices, services, add-ons, video styles and the WhatsApp number here.
// ============================================================

// DIRGA WhatsApp destination number in international format WITHOUT "+" or spaces.
export const WHATSAPP_NUMBER = "6281111126464";

// Moment categories act ONLY as a filter/navigation over services.
// They never add any price on their own.
export const MOMENTS = [
  { id: "lamaran", label: "Lamaran" },
  { id: "prewedding", label: "Prewedding" },
  { id: "akad_resepsi", label: "Akad & Resepsi" },
  { id: "intimate", label: "Intimate Wedding" },
];

// ------------------------------------------------------------
// Gaya video + contoh video di Google Drive.
// drive = kode file Drive, yaitu bagian di antara "/d/" dan "/view" pada link Drive.
// File Drive harus dibagikan sebagai "Siapa saja yang memiliki link" (Viewer).
// ------------------------------------------------------------
export const STYLE_GROUPS = {
  prewedding: [
    { id: "amour", name: "Amour", mood: "Romantic, Emotional", drive: "1joQ3H7y9nekXTIL5iHeXwM9CZHMFbINc" },
    { id: "fun_editorial", name: "Fun Editorial", mood: "Classy, Dance, Fun Music", drive: "1ZjrHduiYIunNzCdsFPQYPiwuiqXoFvnB" },
    { id: "velour", name: "Velour", mood: "Moody, Dramatic, Dark", drive: "1bkCQCMxsKDvQDqc9zXo0sVgQowcObQvx" },
    { id: "dreamy", name: "Dreamy", mood: "Sunset, Natural, Cheerful", drive: "1N68LdGVvAQbXNO2StsXacBRI4VIoPWU0" },
  ],
  wedding: [
    { id: "cinematic_romance", name: "Cinematic Romance", mood: "Romance, Emotional", drive: "1HE4xvErAoIJF1y59A7w7pfFjLyaqj1OU" },
    { id: "storytelling", name: "Storytelling / Documentary", mood: "Natural, Candid, Dialog", drive: "19W1uDyhXIjlsuZhF4ulmXc6AiT7Ag_Eu" },
    { id: "energetic_fun", name: "Energetic & Fun", mood: "Joy & Playful", drive: "1d5Ie68pQujZYIWYhGbmItn_1tbXIb_j-" },
    { id: "classy_luxury", name: "Classy / Luxury", mood: "Elegant Venue, Sophisticated", drive: "1kxZuU0dwxBLofCBCej9f1C6Y3MD5VnIR" },
  ],
};
export const driveEmbedUrl = (id) => `https://drive.google.com/file/d/${id}/preview`;
export const driveViewUrl = (id) => `https://drive.google.com/file/d/${id}/view`;

const DRIVE = "Delivered via Google Drive";
const CINEMA = [
  "Wedding Cinema Full — landscape 16:9 (main video, 3–5 minutes)",
  "Wedding Cinema Highlight — 16:9 / 9:16 (short cinematic edit for Reels/TikTok/Stories, 1 minute)",
];

// Every service is a standalone item. TOTAL = SUM(selected services).
// No bundles, no discounts, no automatic packages.
export const SERVICES = [
  // ---------------- PHOTOGRAPHY ----------------
  {
    id: "photo_lamaran", name: "Photo Lamaran", category: "Photography", price: 1500000,
    meta: "5 Hours · Photography", moments: ["lamaran"], optional: false,
    includes: ["2 Photographers", "Up to 5 hours coverage", "All Edited Photo Files", DRIVE],
  },
  {
    id: "photo_prewed_indoor", name: "Photo Prewed Indoor", category: "Photography", price: 1000000,
    meta: "Per Session · Photography", moments: ["prewedding"], optional: false,
    includes: ["1 Photographer", "1 Indoor Prewedding Session", "All Edited Photo Files", DRIVE],
  },
  {
    id: "photo_prewed_outdoor", name: "Photo Prewed Outdoor", category: "Photography", price: 1500000,
    meta: "Per Session · Photography", moments: ["prewedding"], optional: false,
    includes: ["1 Photographer", "1 Outdoor Prewedding Session", "All Edited Photo Files", DRIVE],
  },
  {
    id: "photo_akad_resepsi", name: "Photo Akad & Resepsi", category: "Photography", price: 3500000,
    meta: "8 Hours · Photography", moments: ["akad_resepsi"], optional: false,
    includes: ["2 Photographers", "Up to 8 hours coverage", "All Edited Photo Files", DRIVE],
  },
  {
    id: "photo_intimate", name: "Photo Intimate Wedding", category: "Photography", price: 3000000,
    meta: "6 Hours · Photography", moments: ["intimate"], optional: false,
    includes: ["2 Photographers", "Up to 6 hours coverage", "All Edited Photo Files", DRIVE],
  },

  // ---------------- VIDEOGRAPHY ----------------
  {
    id: "video_lamaran", name: "Video Lamaran", category: "Videography", price: 1500000,
    meta: "5 Hours · Videography", moments: ["lamaran"], optional: false, styleGroup: "wedding",
    includes: ["1 Videographer", "Up to 5 hours coverage", "Edited Video", DRIVE],
  },
  {
    id: "video_prewed_indoor", name: "Video Prewed Indoor", category: "Videography", price: 1000000,
    meta: "Per Session · Videography", moments: ["prewedding"], optional: false, styleGroup: "prewedding",
    includes: ["1 Videographer", "1 Indoor Prewedding Session", "Edited Video", DRIVE],
  },
  {
    id: "video_prewed_outdoor", name: "Video Prewed Outdoor", category: "Videography", price: 1500000,
    meta: "Per Session · Videography", moments: ["prewedding"], optional: false, styleGroup: "prewedding",
    includes: ["1 Videographer", "1 Outdoor Prewedding Session", "Edited Video", DRIVE],
  },
  {
    id: "video_akad_resepsi", name: "Video Akad & Resepsi", category: "Videography", price: 2500000,
    meta: "8 Hours · Videography", moments: ["akad_resepsi"], optional: false, styleGroup: "wedding",
    includes: ["1 Videographer", "Up to 8 hours coverage", "Edited Video", DRIVE, ...CINEMA],
  },
  {
    id: "video_intimate", name: "Video Intimate Wedding", category: "Videography", price: 2000000,
    meta: "6 Hours · Videography", moments: ["intimate"], optional: false, styleGroup: "wedding",
    includes: ["1 Videographer", "Up to 6 hours coverage", "Edited Video", DRIVE, ...CINEMA],
  },
];

// Add-ons are always optional and always available.
export const ADDONS = [
  { id: "frame_20r", name: "Cetak Frame 20R + Bingkai", category: "Tambahan", price: 500000, meta: "Add-on", optional: true,
    includes: ["20R Photo Print", "Premium Frame", "Ready to display"] },
  { id: "flashdisk", name: "Flashdisk", category: "Tambahan", price: 250000, meta: "Add-on", optional: true,
    includes: ["Flashdisk for physical storage", "A keepsake for your wedding memories"] },
  { id: "album", name: "Album Photo", category: "Tambahan", price: 850000, meta: "Add-on", optional: true,
    includes: ["Box", "20 Printed Pages", "Cover"] },
  { id: "snap_share", name: "Snap Share", category: "Tambahan", price: 400000, meta: "Add-on", optional: true,
    includes: ["Guest photo sharing experience", "Easy photo access for guests", "Social-media friendly", "Instagram-ready sharing"] },
  { id: "mini_studio", name: "Mini Studio", category: "Tambahan", price: 1000000, meta: "Add-on", optional: true,
    includes: ["Mini Studio setup", "Studio-style background"] },
];

// Quick lookup: id -> item
export const ALL_ITEMS = [...SERVICES, ...ADDONS].reduce((acc, item) => {
  acc[item.id] = item;
  return acc;
}, {});
